<template>
  <BaseForm
    id="baseForm"
    class="ombudsman-form"
    :action="action"
    :response-to="responseTo"
    gtm-submit-event="form_submit_ombudsman_form"
  >
    <template #fields>
      <NameField />
      <TelField />
      <EmailField />
      <UnitField />
      <MessageField />
      <FileField />
      <PolicyPrivacyField />
    </template>
  </BaseForm>
</template>

<script>
import BaseForm from "./BaseForm.vue";
import NameField from "./fields/NameField.vue";
import TelField from "./fields/TelField.vue";
import EmailField from "./fields/EmailField.vue";
import UnitField from "./fields/UnitField.vue";
import FileField from "./fields/FileField.vue";
import PolicyPrivacyField from "./fields/PolicyPrivacyField.vue";
import MessageField from "./fields/MessageField.vue";

export default {
  props: {
    action: {
      type: String,
      required: true,
    },
    responseTo: {
      type: String,
      required: true,
    },
  },
  components: {
    BaseForm,
    NameField,
    EmailField,
    TelField,
    UnitField,
    FileField,
    PolicyPrivacyField,
    MessageField,
  },
};
</script>

<style lang="scss">
.ombudsman-form {
  .base-form-fields {
    column-gap: 16px;
    display: grid;
    grid-template-columns: 1fr;
    // @media screen and (min-width: 600.001px) {
    //   grid-template-columns: 1fr 1fr;
    //   & > :nth-child(3),
    //   & > :nth-child(4),
    //   & > :nth-child(5),
    //   & > :nth-child(6) {
    //     grid-column-end: span 2;
    //   }
    // }
  }
}
</style>
